import { union } from 'lodash'

export function getBuiltInTags() {
  // use union to remove duplicates (contact and activity tags are not mutually exclusive)
  return union(
    [
      `AI`,
      `Answering Machine`,
      `Answering Service`,
      `Billing/Insurance`,
      `Billing`,
      `Current Patient`,
      `Drive-by`,
      `Drive-By`,
      `False Lead`,
      `Insurance Issue`,
      `Insurance Referral`,
      `Needs Review`,
      `New Patient Call`,
      `New Patient`,
      `Office Referral`,
      `Orthodontic Office`,
      `Other Language`,
      `Out of Range`,
      `Patient Referral`,
      `Potential Lead`,
      `Print`,
      `Radio`,
      `Repeat`,
      `Sedation`,
      `Social Media`,
      `TV`,
      `Unanswered`,
      `Unscheduled Call`,
      `Unscheduled Chat`,
      `Unscheduled`,
      `Emergency`,
      `No Recording`,
    ],
    getContactBuiltInTags(),
    getActivityBuiltInTags(),
  )
}

export function getContactBuiltInTags() {
  return [
    `No Patient Found`,
    `No Patient Linked`,
    `Broken Appointment`,
    `No Appointment`,
    `Invalid Note`,
    `Appointment Not Scheduled`,
    `Canceled Appointment`,
    `Insurance: State / HMO`,
    `Insurance: Out of Network`,
    `Schedule Availability`,
    `Pricing Too High`,
    `Unable To Contact`,
    `Service Not Offered`,
    `Office Too Far`,
    `Scheduled With Competitor`,
    `Closed Lost: Other`,
    `Wrong Number`,
    `Missed Call`,
    `Callback`,
    `Voicemail`,
    `New Chat`,
    `New Form`,
    `New Online Scheduler`,
    `New Virtual Consultation`,
    `New Patient`,
    `Unscheduled Imported Form`,
  ]
}

export function getContactBuiltInTagColor(name: string) {
  switch (name) {
    case `No Patient Found`:
    case `No Patient Linked`:
    case `Broken Appointment`:
    case `No Appointment`:
    case `Invalid Note`:
    case `Appointment Not Scheduled`:
    case `Canceled Appointment`:
      return `bg-tags-orange`
    case `Insurance: State / HMO`:
    case `Insurance: Out of Network`:
    case `Schedule Availability`:
    case `Pricing Too High`:
    case `Unable To Contact`:
    case `Service Not Offered`:
    case `Office Too Far`:
    case `Scheduled With Competitor`:
    case `Closed Lost: Other`:
    case `Wrong Number`:
      return `bg-tags-salmon`
    case `Missed Call`:
    case `Callback`:
    case `Voicemail`:
    case `New Chat`:
    case `New Form`:
    case `New Online Scheduler`:
    case `New Virtual Consultation`:
      return `bg-tags-blue`
    case `Emergency`:
      return `bg-tags-red`
    default:
      return `bg-tags-silver`
  }
}

export function getActivityBuiltInTags() {
  return [
    `Archived`, // TRK-5348: shown on agent preview/test calls visible to super users
    `Appointment Confirmation`,
    `Appointment Scheduled`,
    `Appointment Rescheduled`,
    `Voicemail`,
    `Missed Call`,
    `No Patient Found`,
    `Callback`,
    `Prescription Question`,
    `Referral Request`,
    `Interoffice Request`,
    `Request for Records`,
    `Other`,
    `Appointment Not Scheduled`,
    `Canceled Appointment`,
    `Insurance: State / HMO`,
    `Insurance: Out of Network`,
    `Service Not Offered`,
    `Abandoned Call`,
    `Wrong Number`,
    `Office Too Far`,
    `Connected`,
    `Not Connected`,
    `Office Transfer`,
    `No Recording`,
  ]
}

export function getActivityBuiltInTagColor(name: string) {
  switch (name) {
    case `Archived`:
      return `bg-tags-amber`
    case `Appointment Confirmation`:
    case `Appointment Scheduled`:
    case `Appointment Rescheduled`:
    case `Connected`:
      return `bg-tags-green`
    case `Voicemail`:
    case `Missed Call`:
    case `Callback`:
    case `Office Transfer`:
      return `bg-tags-blue`
    case `Prescription Question`:
    case `Referral Request`:
    case `Interoffice Request`:
    case `Request for Records`:
    case `Other`:
      return `bg-tags-silver`
    case `Appointment Not Scheduled`:
    case `Canceled Appointment`:
    case `No Patient Found`:
    case `Not Connected`:
      return `bg-tags-orange`
    case `Insurance: State / HMO`:
    case `Insurance: Out of Network`:
    case `Service Not Offered`:
    case `Wrong Number`:
    case `Abandoned Call`:
    case `Office Too Far`:
    case `No Recording`:
      return `bg-tags-salmon`
    case `Emergency`:
      return `bg-tags-red`
    default:
      return `bg-tags-silver`
  }
}
